module.exports = __webpack_public_path__ + "img/a2.ac2d8b6d.png";